import { createApiRef } from '@backstage/frontend-plugin-api';
import {
  OAuthApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  BackstageIdentityApi,
  SessionApi,
} from '@backstage/core-plugin-api';

/**
 * API ref for the custom OIDC authentication provider (Microsoft Entra ID).
 *
 * The id uses the `plugin.app.*` namespace to avoid conflicts with
 * auth-plugin reserved refs (which use the `auth.*` namespace).
 */
export const oidcAuthApiRef = createApiRef<
  OAuthApi &
    OpenIdConnectApi &
    ProfileInfoApi &
    BackstageIdentityApi &
    SessionApi
>({
  id: 'plugin.app.oidc-auth',
});
